import React, { useMemo } from "react"
import Image from "next/image"

import { AffExpertProfile } from "@firmament-packages/aff"

const AffExpertProfileAboutView: React.FunctionComponent<{
    className?: string
    expertProfile: AffExpertProfile
}> = ({ className, expertProfile }) => {
    const containerClassName = useMemo(() => (
        ["grid grid-cols-12 gap-[24px] text-body text-left text-black-900", className]
            .filter((each) => each && each.length > 0)
            .join(" ")
    ), [className])

    return (
        <div id="providerAboutView" className={containerClassName}>
            <div className="col-span-12 sm:col-span-4">
                <div className="relative w-[200px] h-[200px] mx-auto overflow-auto rounded-[4px]">
                    <Image layout="fill" objectFit="cover"
                        src={expertProfile.photo?.actualObject?.url || "/images/ic_avatar.svg"}
                        alt={"Tertiary Icon"} />
                </div>

                <h3 className="mt-[24px] text-title2 text-center">{expertProfile?.name}</h3>
            </div>

            <p className="col-span-12 sm:col-span-8 whitespace-pre-line">{expertProfile?.bio}</p>
        </div>
    )
}

export default AffExpertProfileAboutView
